<template>
<div>
    <loader v-show="isLoading" />
    <div class="tabContent">
        <div class="sectionHeader">
            <div class="sectionHeaderLeft">Building Surveys</div>
            <div class="sectionHeaderRight"><router-link :to="{ path: '/BuildingSurvey', query: { projectId: project.projectId }}" tag="button" class="btn btn-primary btn-block">Add New</router-link></div>
        </div>
        <div style="float: clear" v-show="gridSpecSurveys.tableData.length > 0">
            <v-client-table :data="gridSpecSurveys.tableData" :columns="gridSpecSurveys.columns" :options="gridSpecSurveys.options">
                <template slot="edit" slot-scope="props">
                    <div style="text-align: center;">
                        <router-link :to="{ path: '/BuildingSurvey/' + props.row.buildingSurveyId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                    </div>
                </template>
            </v-client-table>
        </div>
        <div class="sectionHeader">
            <div class="sectionHeaderLeft">File Search</div>
            <div class="sectionHeaderRight" v-show="canAddFileSearch">
                <router-link :to="{ path: '/FileSearch', query: { projectId: project.projectId }}" tag="button" class="btn btn-primary btn-block">Add New</router-link>
            </div>
        </div>
        <div style="float: clear" v-if="canAddFileSearch">
            <v-client-table :data="gridSpecFileSearches.tableData" :columns="gridSpecFileSearches.columns" :options="gridSpecFileSearches.options">
                <template slot="edit" slot-scope="props">
                    <div style="text-align: center;">
                        <router-link :to="{ path: '/FileSearch/' + props.row.fileSearchId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                    </div>
                </template>
                <template slot="result" slot-scope="props">
                    <div style="text-align: center;" v-if="props.row.hasResults">
                        <router-link :to="{ path: '/FileSearch/' + props.row.fileSearchId, hash: '#files' }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                    </div>
                </template>
                <template slot="delete" slot-scope="props">
                    <div style="text-align: center;">
                        <a class="fa fa-ban" style="font-size: 18px;" v-if="props.row.canBeDeleted" v-on:click="deleteFileSearch(props.row.fileSearchId)"></a>
                    </div>
                </template>
            </v-client-table>
        </div>
        <div v-else class="alert alert-info" role="alert">
            <strong>The file search will be performed by SHPO</strong>
        </div>
        &nbsp;<br/> <!-- BUG! not sure why the next section header doesnt show if I don't have this -->
        <div class="sectionHeader">
            <div class="sectionHeaderLeft">Reconnaissance Forms</div>
            <div class="sectionHeaderRight" v-show="canSelectSite">
                <router-link :to="{ path: '/BuildingReconSiteSelection', query: { buildingSurveyId: buildingSurvey.buildingSurveyId }}" tag="button" class="btn btn-primary btn-block">Site Selection</router-link>
            </div>
            <div class="sectionHeaderRight" v-show="canAddForm">
                <router-link :to="{ path: '/BuildingReconForm', query: { buildingSurveyId: buildingSurvey.buildingSurveyId }}" tag="button" class="btn btn-primary btn-block">Add New</router-link>
            </div>
        </div>
        <div style="float: clear" v-if="canAddForm">
            <v-client-table :data="gridSpecReconForm.tableData" :columns="gridSpecReconForm.columns" :options="gridSpecReconForm.options">
                <template slot="edit" slot-scope="props">
                    <div style="text-align: center">
                        <a class="fa fa-edit" style="font-size: 18px;" v-on:click="goReconForm(props.row.buildingReconFormId)"></a>
                        <!-- <router-link :to="{ path: '/BuildingReconForm/' + (props.row.buildingReconFormId || '?buildingSurveyId=' + buildingSurvey.buildingSurveyId) }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link> -->
                    </div>
                </template>
            </v-client-table>
        </div>
        <div v-else class="alert alert-info" role="alert">
            <strong>The reconnaissance forms will be available after SHPO reviews the survey request</strong>
        </div>
    </div>
</div>
</template>

<script>

import fileSearchService from '@/services/fileSearchService'
import buildingSurveyService from '@/services/buildingSurveyService'
import buildingReconFormService from '@/services/buildingReconFormService'
import culturalResourceRecordingService from '@/services/culturalResourceRecordingService'
import loggingService from '@/services/util/loggingService'
import userService from '@/services/userService'
import roleService from '@/services/roleService'
import workflowService from '@/services/workflowService'

import loader from '@/components/Loader'
import projectHeader from '@/components/ProjectHeader'
import { mapState } from 'vuex'

export default {
    name: 'BuildingSurveyActions',
    props: ['project'],
    components: {
        loader,
        projectHeader
    },
    computed: {
        canAddFileSearch: function () {
            var acceptableRoles = [
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser
            ]
            return userService.hasRoleCheck(this.shpoUserDto.roleList, acceptableRoles)
        },
        canAddForm: function () {
            return this.workflowInstanceStatusDtoList.find(x => {
                return (x.workflowStatusId === buildingSurveyService.buildingWorkflowStatusEnum.pendingSurvey)
            })
        },
        canSelectSite: function () {
            var acceptableRoles = [
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser
            ]

            var hasApprovedRole = userService.hasRoleCheck(this.shpoUserDto.roleList, acceptableRoles)
            var hasRightStatus = this.workflowInstanceStatusDtoList.find(x => {
                return (x.workflowStatusId === buildingSurveyService.buildingWorkflowStatusEnum.pendingSHPOApproval)
            })
            return hasApprovedRole && hasRightStatus
        },
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        })
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            buildingSurvey: {},
            workflowInstanceStatusDtoList: [],
            gridSpecSurveys: {
                columns: ['edit', 'surveyName', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    dateColumns: ['reportDate'],
                    headings: {
                        edit: 'View/Edit',
                        surveyName: 'Survey Name',
                        createdDate: 'Created Date'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            },
            gridSpecFileSearches: {
                columns: ['edit', 'workflowStatusDescription', 'fileSearchId', 'createdDate', 'plssLocationCount', 'billAmount', 'result', 'delete'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    dateColumns: ['createdDate'],
                    headings: {
                        fileSearchId: 'File Search #',
                        createdDate: 'Date of Entry',
                        workflowStatusDescription: 'Status',
                        plssLocationCount: '# of Sections',
                        billAmount: 'Bill Amount',
                        delete: 'Delete'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            },
            gridSpecReconForm: {
                columns: ['edit', 'smithsonianNumber', 'fieldNumber', 'historicName', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    dateColumns: ['createdDate'],
                    headings: {
                        edit: 'View/Edit',
                        smithsonianNumber: 'Smithsonian Number',
                        fieldNumber: 'Field Number',
                        historicName: 'Historic Name',
                        createdDate: 'Date Created'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            }
        }
    },
    mounted () {
        this.log('mounted')
        this.loadActions()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'BuildingReconForm', message)
        },
        loadActions () {
            if (!this.project.projectId) {
                this.log('No projectId, not loading actions')
                return
            }
            this.isLoading = true
            this.log('Loading actions')
            var searchDto = {projectId: this.project.projectId}
            var surveyPromise = buildingSurveyService.search(this.$http, searchDto).then(surveyResponse => {
                this.log('loadActions - buildingSurvey.search: ' + surveyResponse.data.length)

                //Currently there is only one building survey for each project. Hence the array of one hackery
                this.buildingSurvey = surveyResponse.data[0]
                this.gridSpecSurveys.tableData = [this.buildingSurvey]
                return surveyResponse
            })
            var fileSearchPromise = fileSearchService.search(this.$http, searchDto).then(fileSearchResponse => {
                this.log('loadActions - fileSearchService.search')
                this.gridSpecFileSearches.tableData = fileSearchResponse.data
                return fileSearchResponse
            })
            Promise.all([surveyPromise, fileSearchPromise]).then(results => {
                this.loadDependents(this.buildingSurvey).then(dependentResponse => {
                    this.log('completed loading dependents')
                    this.isLoading = false
                })
            })
        },
        loadDependents () {
            if (!this.buildingSurvey.buildingSurveyId) return Promise.Resolve(1)

            var surveyId = this.buildingSurvey.buildingSurveyId
            var reconFormPromise = buildingReconFormService.search(this.$http, {buildingSurveyId: surveyId}, false).then(formResponse => {
                this.log('loadDependents - reconForm.search')
                this.gridSpecReconForm.tableData = formResponse.data.filter(x => x.recordingTypeId !== culturalResourceRecordingService.RecordingTypeEnum.OutsideAPE)
                return formResponse
            })

            var workflowHistoryPromise = workflowService.listWorkflowStatusByParent(this.$http, workflowService.WorkflowEnum.BuildingSurvey, surveyId).then(workflowResponse => {
                this.log('loadDependents - workflowHistoryList: ' + workflowResponse)
                this.workflowInstanceStatusDtoList = workflowResponse.data
                return workflowResponse
            })

            return Promise.all([reconFormPromise, workflowHistoryPromise]).then(response => {
                return response
            })
        },
        goReconForm (id) {
            var url = '/BuildingReconForm/' + (id || '?buildingSurveyId=' + this.surveyDto.buildingSurveyId)
            this.log('url:' + url)
            this.$router.push(url)
        }
    }
}
</script>


<style>

.text-label {
    line-height: 24px !important;
}

.tabContent {
    margin-left: 30px;
}

.sectionHeader {
    overflow: hidden;
}

.sectionHeaderLeft {
    float: left;
    font-size: 18px;
}

.sectionHeaderRight {
    float: right;
}

</style>



// WEBPACK FOOTER //
// BuildingSurveyActions.vue?ea11fcf0